// Webpack Imports
//import * as bootstrap from 'bootstrap';

// Modules / Classes
import boxheight from "./js/boxheight";
import keenslider from './js/keenslider';
import basicLightbox from './js/basiclightbox';
import Main from './js/Main'
import Clipping from './js/Clipping'
import Locanda from './js/Locanda'
import MenuRistorante from './js/MenuRistorante'
import Prenota from './js/Prenota'


// Instantiate a new object using our modules/classes
const main = new Main();
const clipping = new Clipping();
const locanda = new Locanda();
const menuRistorante = new MenuRistorante();
const prenota = new Prenota();

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// sameheight
    let sameheight = document.querySelectorAll(".sameheight");
    boxheight(sameheight);

	// slider
	keenslider();

	// click video
	basicLightbox();
	
} )();